import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApiImageModule } from '@digipay/ng-ui-api-image';
import { NgxBadgeModule } from '@digipay/ngx-badge';

@Component({
  selector: 'daily-stores-logo-with-rate',
  standalone: true,
  imports: [CommonModule, ApiImageModule, NgxBadgeModule],
  templateUrl: './logo-with-rate.component.html',
  styleUrl: './logo-with-rate.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoWithRateComponent {
  backgroundMode = input<'elevated' | 'back'>('elevated');
  logoImageId = input<string>('');
  score = input(0, {
    transform: (value: number | undefined) => (value ? Number(value?.toFixed(1)) : 0),
  });
  borderRadius = computed(() => (this.score() ? '100px 100px 45px 45px' : '24px'));
}
